const MotionGlobalConfig = {
  skipAnimations: false,
  useManualTiming: false
};
export {
  MotionGlobalConfig
};
//# sourceMappingURL=GlobalConfig.js.map
